import React from 'react';
import '../css/about.css'
import Footer from './Footer';
import about from '../img/abouts.jpg'

const About = () => {
    return (

        <>


            <div className='headings'>
                <h1>About Us</h1>
            </div>


            <div className='section-up'>

                <div className='consultant'>
                    <h1>Hope Rise Multi- Speciality Hospital
                    </h1>
                    <h2>A Unit Of Hope Rise  Hospital Private Limited
                    </h2>

                    <hr style={{ border: 'none', height: '3px', backgroundColor: 'red', margin: '20px 0' }} />


                    <p> 🟢 Welcome to Hope Rise Multi-Specialty Hospital, a trusted healthcare provider and a unit of Hope Rise Hospital Private Limited. We are dedicated to delivering comprehensive, compassionate care across a wide range of medical specialties. Established with a vision to provide top-quality healthcare to individuals and families, we are committed to setting new standards in medical excellence, patient care, and innovative treatment.</p>
                    <p style={{ color: ' #2980b9' }}> 🟢 Our Mission Our mission is to provide accessible, affordable, and high-quality healthcare, ensuring every patient receives the best possible treatment tailored to their unique needs. We focus on offering patient-centered care, driven by advanced medical technology, highly skilled doctors, and a dedicated support team.
                    </p>


                    <p>🟢 <b> Dr. Minhaz Ahmad MD, DNB, PDCC, (HEPATOLOGY)</b> </p>
                    <p>Former Consultant</p>
                    <p>Dr. Ram Manohar Lohia Institute of Medical Sciences, Lucknow
                        <span style={{ color: 'red', fontWeight: 'bold' }}> SGPGI</span> MS, Lucknow ,

                        <span style={{ color: 'red', fontWeight: 'bold' }}> AIIMS </span>  New Delhi ,
                        JASLOK Hospital Mumbai</p>








                </div>


                <div className='consultant2'>
                    <img src={about} />
                </div>

            </div>
            <hr />

            <Footer />
        </>
    );
};

export default About;
